import type { QueryDocumentSnapshot, SnapshotOptions} from "firebase/firestore";
import { Timestamp } from "firebase/firestore"
import type { ICaseRequest } from "~~/types/case-request"
import compactObject from "~/utils/compact-object"

export const caseRequestConverter = {
  toFirestore(data: Partial<ICaseRequest>): any {
    // Convert Date objects to Firestore Timestamps
    const convertDates = (obj: any): any => {
      const result: any = {}
      for (const key in obj) {
        if (obj[key] instanceof Date) {
          result[key] = Timestamp.fromDate(obj[key])
        } else if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
          result[key] = convertDates(obj[key])
        } else {
          result[key] = obj[key]
        }
      }
      return result
    }

    // Simply convert dates and remove undefined values
    const converted = convertDates(data)

    // Remove undefined values
    return compactObject(converted)
  },

  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): ICaseRequest {
    const data = snapshot.data(options)

    // Convert Firestore Timestamps to Date objects
    const convertTimestamps = (value: any): any => {
      if (value instanceof Timestamp) {
        return value.toDate()
      }
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const result: any = {}
        for (const key in value) {
          result[key] = convertTimestamps(value[key])
        }
        return result
      }
      return value
    }

    // Convert timestamps and provide defaults for required fields
    const converted = convertTimestamps(data)

    return {
      id: snapshot.id,
      ...converted,
      // Provide defaults for required fields if missing
      customer: converted.customer || {
        name: '',
        contactNum: '',
        vehicle: {
          regNum: '',
          model: '',
          color: ''
        }
      },
      location: converted.location || {
        from: {
          coord: { latitude: 0, longitude: 0 },
          address: '',
          generatedAddress: ''
        },
        to: {
          coord: { latitude: 0, longitude: 0 },
          address: '',
          generatedAddress: ''
        },
        distance: 0,
        state: [],
        city: ''
      },
      choosedService: converted.choosedService || [],
      remarks: converted.remarks || {
        external: [],
        internal: []
      },
      timestamps: converted.timestamps || {
        createdAt: new Date(),
        updatedAt: new Date()
      },
      // Ensure boolean fields have defaults
      policeReport: converted.policeReport || false,
      basementTowing: converted.basementTowing || false,
    }
  }
}